import { buildPolygonStyle, POLYGON_UNSELECTED_COLOR } from 'lib/map';
import { Source } from 'react-map-gl';
import { Layer } from './ordered-layer';

const STYLE = buildPolygonStyle({ color: POLYGON_UNSELECTED_COLOR });

interface Props {
  geometry?: GeoJSON.Geometry;
  id: number | string;
  /** Layer id suffix when several polygons share a feature `id`; defaults to `id`. */
  layerKey?: string;
  color?: string;
  style?: typeof STYLE;
  showBorder?: boolean;
  beforeId?: string;
}

const PolygonArea = ({
  geometry,
  id,
  layerKey = String(id),
  color,
  style,
  showBorder = true,
  beforeId,
}: Props) => {
  style = !style ? (!color ? STYLE : buildPolygonStyle({ color })) : style;
  return geometry &&
    ['Polygon', 'MultiPolygon', 'GeometryCollection'].includes(
      geometry.type
    ) ? (
    <Source
      type="geojson"
      data={{
        type: 'FeatureCollection',
        features: [
          {
            type: 'Feature',
            geometry: geometry,
            properties: null,
            id: id,
          },
        ],
      }}
    >
      <Layer
        key={`fill-${layerKey}`}
        id={`polygon-fill-${layerKey}`}
        type="fill"
        paint={style.fill}
        beforeId={beforeId}
      />
      {showBorder && (
        <Layer
          key={`line-${layerKey}`}
          id={`polygon-line-${layerKey}`}
          type="line"
          paint={style.line}
          beforeId={beforeId}
        />
      )}
    </Source>
  ) : null;
};

export default PolygonArea;
